export default __webpack_public_path__ + "static/media/DINPro-Bold.60ff69c9.ttf";